module.exports = __webpack_public_path__ + "media/images/wedding/events/afterwedding-b9ecba5135b5e65672da4e6955d8431c.jpg";